import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {Router} from '@angular/router';
import {BooleanInput} from '@angular/cdk/coercion';
import {Subject, takeUntil} from 'rxjs';
import {User} from '@models/user.interface';
import {UserService} from 'app/core/user/user.service';
import {AccountRole} from "../../../enums/AccountRole";
import {FuseFullscreenComponent} from '@fuse/components/fullscreen/fullscreen.component';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: false
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    static ngAcceptInputType_showHelp: BooleanInput;
    static ngAcceptInputType_showFullscreen: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    @Input() showHelp: boolean = false;
    @Input() showFullscreen: boolean = false;
    @Input() actionIcon: string = 'heroicons_outline:user-circle';
    @Input() actionLabel: string | null = null;
    @ViewChild(FuseFullscreenComponent) private _fullscreen: FuseFullscreenComponent;
    user: User;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    toggleFullscreen(): void {
        // Keep the native request synchronous with the menu item's user gesture.
        this._fullscreen?.toggleFullscreen();
    }

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    /**
     * Get profile by role
     */
    linkProfile(): string {
        switch (this.user.rol) {
            case AccountRole.master:
                return '/master/profile';
                break;
            case AccountRole.adminHotel:
                return '/hotels/profile';
                break;
            case AccountRole.accountant:
                return '/master/profile';
                break;
            case AccountRole.provider:
                return '/master/profile';
                break;
        }
    }
}
